
  <div>
    <div class="head-section">
        <h6 class="header-text text-white">Crop Picture</h6>
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="close()">
            <g clip-path="url(#clip0_3558_32756)">
                <path d="M1.96338 16.9345L9.47846 9.41938M16.9935 1.9043L9.47703 9.41938M9.47703 9.41938L1.96338 1.9043M9.47846 9.41938L16.9935 16.9345" stroke="#F00000" stroke-width="2.16781" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
                <clipPath id="clip0_3558_32756">
                    <rect width="17.3425" height="17.3425" fill="white" transform="translate(0.806641 0.748047)"/>
                </clipPath>
            </defs>
        </svg>
    </div>
    <div class="body-section">
        <div class="center-content">

            <div class="m-3" *ngIf="!imageSrc">
                <img src="assets/ass-user.svg" style="width:300px ;border-radius: 5px" alt="user" />
            </div>
      
          <input id="photo" type="file" (change)="selectDocument($event)" style="display: none;" #fileInput />
      
          <div>
            <image-cropper *ngIf="imageSrc"
            [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="true"
            [aspectRatio]="4/3"
            [resizeToWidth]="200"
            [resizeToHeight]="200"
            format="png"
            outputFormat="base64"
            (imageCropped)="imageCropped($event)"
            [containWithinAspectRatio] = "true"
            [allowMoveImage] = "true"
           
           
          ></image-cropper>
        </div>
          </div>
      </div>


      <div class="modal-footer">
        <div class="action-buttons">

            <img (click)="fileInput.click()" src="assets/img/ICON/select-button.svg" style="width: 45%;" alt="select button" />

            <img *ngIf="imageSrc" (click)="uploadProfile()" src="assets/img/ICON/upload-button.svg" style="width: 45%;" alt="upload button" />

            <img *ngIf="!imageSrc" src="assets/img/ICON/upload-button-disable.svg" style="width: 45%;" alt="upload button" />
            
        </div>

       
    </div>
      
</div>